import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getParticipantesReal } from '../services/participantesService';
import { rgb, ROJO, cabeceraPDF } from './cabeceraFmds';
import { clasificarActa } from './jornadasUtils';

const COLUMNAS = ['LOCAL', 'VISITANTE', 'SET 1', 'SET 2', 'SET 3', 'SETS', 'NOTA'];

const celdasSets = (p) => {
  const sets = Array.from({ length: 3 }, (_, i) => p.sets.find((s) => s.numero === i + 1));
  const ganados = (lado) => p.sets.filter((s) => (lado === 'L' ? s.puntosLocal > s.puntosVisitante : s.puntosVisitante > s.puntosLocal)).length;
  return [
    ...sets.map((s) => (s ? `${s.puntosLocal}-${s.puntosVisitante}` : '')),
    p.sets.length ? `${ganados('L')}-${ganados('V')}` : '',
  ];
};

const fila = (p, nota) => [p.local_nombre, p.visitante_nombre, ...celdasSets(p), nota];

const MODALIDADES = ['DOBLES FEMENINO', 'DOBLES MASCULINO', 'DOBLES MIXTO', 'INDIVIDUAL FEMENINO', 'INDIVIDUAL MASCULINO'];

// Acta de una jornada: puntuación de los partidos en tres bloques (ver clasificarActa),
// cada uno con una tabla por modalidad. `cuadrante` son los partidos del cuadrante de la jornada.
export async function descargarActaPDF(partidos, temporada, jornada, cuadrante, nombreArchivo) {
  const participantes = await getParticipantesReal(temporada);
  const descalificados = new Set(participantes.filter((p) => p.estado === 'DESCALIFICADO').map((p) => p.participante_id));
  const { programados, adelantados, apartados } = clasificarActa(partidos, jornada, cuadrante, descalificados);

  const doc = new jsPDF({ orientation: 'landscape' });
  const ancho = doc.internal.pageSize.getWidth();
  let y = await cabeceraPDF(doc, temporada);
  doc.setFont('helvetica', 'bold').setFontSize(12);
  doc.text(`ACTA JORNADA ${jornada}`, ancho / 2, 40, { align: 'center' });

  const bloques = [
    ['PARTIDOS DE LA JORNADA', programados, () => ''],
    ['PARTIDOS ADELANTADOS JUGADOS EN ESTA JORNADA', adelantados, (p) => `Jornada ${p.jornada}`],
    ['WO / APLAZADOS / DESCALIFICADOS', apartados, (p) => p.motivos.join(' · ')],
  ];
  bloques.forEach(([titulo, lista, nota]) => {
    if (y > 170) { doc.addPage(); y = 15; }
    doc.setFont('helvetica', 'bold').setFontSize(11).setTextColor(...rgb(ROJO));
    doc.text(titulo, 10, y + 4);
    doc.setTextColor(0);
    y += 8;
    if (!lista.length) {
      doc.setFont('helvetica', 'italic').setFontSize(9);
      doc.text('Ninguno', 10, y + 3);
      y += 10;
      return;
    }
    MODALIDADES.filter((m) => lista.some((p) => p.modalidad === m)).forEach((modalidad) => {
      autoTable(doc, {
        startY: y,
        margin: { left: 10, right: 10 },
        head: [
          [{ content: modalidad, colSpan: COLUMNAS.length, styles: { halign: 'left', fontSize: 9 } }],
          COLUMNAS,
        ],
        body: lista.filter((p) => p.modalidad === modalidad).map((p) => fila(p, nota(p))),
        theme: 'grid',
        styles: { fontSize: 8, cellPadding: 2, valign: 'middle', lineColor: [184, 176, 204] },
        headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'center', lineColor: 0 },
        columnStyles: { 0: { cellWidth: 60 }, 1: { cellWidth: 60 }, 2: { halign: 'center' }, 3: { halign: 'center' }, 4: { halign: 'center' }, 5: { halign: 'center' } },
      });
      y = doc.lastAutoTable.finalY + 6;
    });
    y += 4;
  });
  doc.save(nombreArchivo);
}
